var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topnav'),_c('div',{staticClass:"page-wrap"},[_c('h1',{staticClass:"txt160 serif light"},[_vm._v(" "+_vm._s(_vm.$t('Thank you for your trust'))+" ")]),_c('p',{staticClass:"form-title"},[_vm._v(" "+_vm._s(_vm.$t('We will be in touch with you soon'))+" ")])]),_c('botfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }